import React from 'react'

function AboutChooseUs() {
  return (
    <div>
      <section className='py-xl-5' >
        <div className='container choose_us_container '>
          <div className='row choose_us_row'>
            <div className='col-12 about-choose-us-main-heading-col'>
              <h3 className='text-center' >Why Choose Us</h3>
            </div>
            <div className='col-sm-12 col-md-6 col-xl-3'>
              <div className='about-choose-us-main '>
                <div className="about_choose_us_img">
                  <img src="/images/aboutus_icons/plus.png" alt="hand-icon" />
                </div>
                <h6>Property Insurance</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>

              </div>
            </div>
            <div className='col-sm-12 col-md-6 col-xl-3'>
              <div className='about-choose-us-main '>
                <div className="about_choose_us_img">
                  <img src="/images/aboutus_icons/home.png" alt="hand-icon" />
                </div>
                <h6>Quality House</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>

              </div>
            </div>
            <div className='col-sm-12 col-md-6 col-xl-3'>
              <div className='about-choose-us-main '>
                <div className="about_choose_us_img">
                  <img src="/images/aboutus_icons/support.png" alt="hand-icon" />
                </div>
                <h6>Quality House</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>

              </div>
            </div>
            <div className='col-sm-12 col-md-6 col-xl-3'>
              <div className='about-choose-us-main '>
                <div className="about_choose_us_img">
                  <img src="/images/aboutus_icons/check.png" alt="hand-icon" />
                </div>
                <h6>Lowest Maintenance</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>

              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}

export default AboutChooseUs
